
<div>
  <template v-if="component=='catalog'">
    <Catalog/>
  </template>
  <template v-else>
    <Default/>
  </template>
</div>
